module.exports = __webpack_public_path__ + "static/img/2.e1590fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/eng/2.png
// module id = rL26
// module chunks = 0